import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import HSTable from '../../../../common/HSTable';
import { commaSeperator } from '../../../../utils/validation';
import { Reporting, UpdatePortfolioDoc } from '../../redux/types';
import { getReportColor } from '../../utils';

type Props = {
    list: UpdatePortfolioDoc[];
};

const DesktopUpdatedDocuments: React.FC<Props> = ({ list }) => {
    const navigate = useNavigate();
    const loading = useSelector((state: RootState) => state.investments.loadingUpdate);

    const columns = [
        {
            dataIndex: 'obligationDate',
            title: 'Reporting Date',
            width: 100,
            render: (text?: { date: string }) => <p>{moment(text?.date).format('DD-MMM-YYYY')}</p>,
            sorter: (a: UpdatePortfolioDoc, b: UpdatePortfolioDoc) =>
                moment(a.obligationDate?.date).unix() - moment(b.obligationDate?.date).unix(),
        },
        {
            dataIndex: 'issuerName',
            title: 'Issuer',
            width: 200,
            render: (text?: string) => <p>{text}</p>,
        },
        {
            dataIndex: 'reports',
            title: 'Booking',
            width: 200,
            render: (text: Reporting[]) => {
                let data = (text || []).length > 0 ? text[0] : undefined;
                return (
                    <span>
                        {data
                            ? `${
                                  data.maturityDate?.date ? moment(data.maturityDate.date).format('DD/MM/YYYY') : ''
                              } | ${
                                  data?.amountBorrowed?.amountUpto2dp
                                      ? `${data.amountBorrowed.currency} ${commaSeperator(
                                            parseFloat(String(data.amountBorrowed.amountUpto2dp || 0)).toFixed(2),
                                        )}`
                                      : ''
                              } | ${data.interestRate ? `${data.interestRate}%` : ''}`
                            : '-'}
                    </span>
                );
            },
        },
        {
            dataIndex: 'reports',
            title: 'Report',
            width: 200,
            render: (text: Reporting[], row: UpdatePortfolioDoc) => (
                <>
                    <p className={`whitespace-pre-wrap`}>
                        {[...text]
                            .filter((a, i, self) => self.findIndex((s) => s.obligationType === a.obligationType) === i)
                            ?.map((t, index) => (
                                <span
                                    className={getReportColor(t.uploadDetails || [], row.obligationDate?.date || '')}
                                    key={`${index}_${t.obligationType}`}
                                >
                                    {index === 0 ? `${t.obligationType}` : `, ${t.obligationType}`}
                                </span>
                            ))}
                    </p>
                </>
            ),
        },
    ];
    return (
        <div>
            <HSTable
                tableContainer={'investment'}
                columns={columns}
                data={[...list]}
                loading={loading}
                rowKey={(d: UpdatePortfolioDoc) =>
                    `${d.obligationDate?.date}_${new Date().getMilliseconds()}_${d.investmentUUID}_${uuidv4()}`
                }
                onRowClick={(i: UpdatePortfolioDoc) =>
                    navigate(`${HEADERMENU_PATH.investments}/${i.investmentUUID}?tab=document`, {
                        state: { date: i.obligationDate?.date },
                    })
                }
                pagination={{ isShow: true }}
                paginationPosition="bottomRight"
            />
        </div>
    );
};

export default DesktopUpdatedDocuments;
